module.exports = __webpack_public_path__ + "static/aboleth_at_ocean-a898a941b6f406205397feb8f7a02599.jpg";